const sharedLabels = {
  fr: {
    title: 'Commander une traduction en ligne',
    subtitle: 'Décrivez votre besoin en quelques étapes. Paiement sécurisé après confirmation.',
    successTitle: 'Commande enregistrée !',
    successText: 'Votre commande a bien été créée. Vous pouvez la suivre dans votre espace client.',
    successOrder: 'N° de commande',
    viewOrders: 'Voir mes commandes',
    backHome: 'Retour à l’accueil',
    next: 'Suivant',
    prev: 'Précédent',
    submit: 'Confirmer la commande',
    submitting: 'Envoi en cours…',
    loginToOrder: 'Connectez-vous pour confirmer votre commande.',
    loginRestored: 'Vous êtes connecté. Vérifiez votre commande puis cliquez sur « Confirmer la commande ».',
    submitError: 'Impossible d’enregistrer la commande. Réessayez.',
    needLangPair: 'Indiquez au moins une combinaison de langues.',
    needDocument: 'Sélectionnez un type de document.',
    required: 'Champ obligatoire',
    optional: 'optionnel',
    addLangPair: 'Ajouter une combinaison',
    removeLangPair: 'Retirer',
    sourceLang: 'Langue source',
    targetLang: 'Langue cible',
    choose: 'Choisir…',
    stepOf: 'Étape',
    sideTitle: 'Votre demande',
    stepHints: {
      1: 'Vos coordonnées',
      2: 'Traduction ou interprétariat',
      3: 'Combinaisons linguistiques',
      4: 'Détails et fichiers',
      5: 'Réception du travail',
      6: 'Instructions particulières',
      7: 'Vérification et envoi',
    },
    trust: {
      fast: 'Réponse sous 30 minutes ouvrées',
      payment: 'Paiement sécurisé en ligne',
      secure: 'Documents traités en toute confidentialité',
    },
    help: {
      title: 'Besoin d’aide ?',
      text: 'Notre équipe vous accompagne pour préparer votre demande.',
      call: 'Appeler',
      write: 'Nous écrire',
    },
    pricing: {
      title: 'Estimation du prix',
      document: 'Document',
      base: 'Traduction',
      quantity: 'Nombre de pages',
      apostilleOriginal: 'Apostille doc. original',
      apostilleTranslated: 'Apostille doc. traduit',
      total: 'Total estimé',
      pending: 'Sélectionnez un type de document pour afficher le prix.',
      quoteOnly: 'Prix sur devis',
      paymentNote: 'Le paiement sécurisé sera effectué après confirmation de la commande.',
    },
    steps: {
      1: 'Client',
      2: 'Service',
      3: 'Langues',
      4: 'Projet',
      5: 'Livraison',
      6: 'Commentaires',
      7: 'Validation',
    },
    stepTitles: {
      1: 'Informations du client',
      2: 'Sélection du service',
      3: 'Langues',
      4: 'Informations sur le projet',
      5: 'Livraison',
      6: 'Commentaires',
      7: 'Validation',
    },
    client: {
      section: 'Coordonnées',
      civility: 'Civilité',
      lastName: 'Nom',
      firstName: 'Prénom',
      company: 'Entreprise / Organisation',
      role: 'Fonction',
      email: 'E-mail',
      phone: 'Téléphone',
      country: 'Pays',
      city: 'Ville',
    },
    service: {
      category: 'Catégorie',
      translation: 'Traduction',
      interpreting: 'Interprétariat',
      translationService: 'Service demandé',
      interpretingType: 'Type d’interprétation',
    },
    project: {
      documentType: 'Type de document',
      domain: 'Domaine',
      pages: 'Nombre de pages',
      words: 'Nombre de mots',
      fileCount: 'Nombre de fichiers',
      formats: 'Format du document',
      upload: 'Téléversement des fichiers',
      uploadHint: 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, ZIP…',
      dragDrop: 'Ajoutez un ou plusieurs fichiers',
      extras: 'Options supplémentaires',
      deadline: 'Délai souhaité',
      deadlineDate: 'Date précise',
      missionType: 'Type de mission',
      missionDate: 'Date de la mission',
      startTime: 'Heure de début',
      endTime: 'Heure de fin',
      duration: 'Durée estimée',
      place: 'Lieu',
      placeCountry: 'Pays',
      placeCity: 'Ville',
      address: 'Adresse',
      mode: 'Mode',
      onsite: 'Présentiel',
      remote: 'À distance',
      platform: 'Plateforme',
      participants: 'Nombre de participants',
      equipment: 'Besoin en matériel',
    },
    delivery: {
      mode: 'Mode de livraison souhaité',
    },
    comments: {
      label: 'Instructions particulières',
      placeholder:
        'Contraintes terminologiques, glossaire à respecter, mise en page spécifique, exigences du client…',
    },
    validation: {
      accurate: 'J’atteste que les informations fournies sont exactes.',
      privacy: 'J’accepte la politique de confidentialité.',
      terms: 'J’accepte les conditions générales.',
    },
    languages: {
      ar: 'Arabe',
      fr: 'Français',
      en: 'Anglais',
      it: 'Italien',
      de: 'Allemand',
      es: 'Espagnol',
      ru: 'Russe',
      pt: 'Portugais',
      tr: 'Turc',
      zh: 'Chinois',
      other: 'Autre',
    },
    countries: {
      TN: 'Tunisie',
      FR: 'France',
      IT: 'Italie',
      DE: 'Allemagne',
      BE: 'Belgique',
      CH: 'Suisse',
      CA: 'Canada',
      AE: 'Émirats arabes unis',
      SA: 'Arabie saoudite',
      MA: 'Maroc',
      DZ: 'Algérie',
      other: 'Autre',
    },
    translationServices: {
      official: 'Traduction officielle',
      sworn: 'Traduction assermentée',
      certified: 'Traduction certifiée',
      legal: 'Traduction juridique',
      technical: 'Traduction technique',
      medical: 'Traduction médicale',
      financial: 'Traduction financière',
      commercial: 'Traduction commerciale',
      marketing: 'Traduction marketing',
      it: 'Traduction informatique',
      scientific: 'Traduction scientifique',
      audiovisual: 'Traduction audiovisuelle',
      tourism: 'Traduction touristique',
      literary: 'Traduction littéraire',
      luxury: 'Traduction dans le luxe',
      digital: 'Traduction digitale',
      website: 'Traduction de site Internet',
      softwareLocalization: 'Localisation de logiciels',
      appLocalization: 'Localisation d’applications',
      seo: 'Traduction SEO',
    },
    interpretingTypes: {
      simultaneous: 'Interprétation simultanée',
      consecutive: 'Interprétation consécutive',
      liaison: 'Interprétation de liaison',
      judicial: 'Interprétation judiciaire',
      medical: 'Interprétation médicale',
      commercial: 'Interprétation commerciale',
      phone: 'Interprétation téléphonique',
      video: 'Interprétation en visioconférence',
    },
    documentTypes: {
      civilStatus: 'Acte d’état civil',
      diploma: 'Diplôme',
      passport: 'Passeport',
      idCard: 'Carte d’identité',
      drivingLicense: 'Permis de conduire',
      contract: 'Contrat',
      judgment: 'Jugement',
      notarialAct: 'Acte notarié',
      medicalReport: 'Rapport médical',
      technicalManual: 'Manuel technique',
      catalog: 'Catalogue',
      brochure: 'Brochure',
      website: 'Site Internet',
      mobileApp: 'Application mobile',
      softwareDocs: 'Documentation logicielle',
      scientificArticle: 'Article scientifique',
      cv: 'CV',
      letter: 'Lettre',
      other: 'Autre',
    },
    domains: {
      legal: 'Juridique',
      medical: 'Médical',
      technical: 'Technique',
      commercial: 'Commercial',
      financial: 'Financier',
      marketing: 'Marketing',
      it: 'Informatique',
      scientific: 'Scientifique',
      tourism: 'Tourisme',
      luxury: 'Luxe',
      education: 'Éducation',
      industry: 'Industrie',
      other: 'Autre',
    },
    formats: {
      pdf: 'PDF',
      word: 'Word',
      excel: 'Excel',
      powerpoint: 'PowerPoint',
      image: 'Image',
      indesign: 'InDesign',
      autocad: 'AutoCAD',
      html: 'HTML',
      xml: 'XML',
      other: 'Autre',
    },
    extras: {
      proofreading: 'Relecture linguistique',
      sameLayout: 'Mise en page identique au document original',
      certified: 'Traduction certifiée',
      sworn: 'Traduction assermentée',
      enhancedPrivacy: 'Confidentialité renforcée',
    },
    deadlines: {
      standard: 'Standard',
      priority: 'Prioritaire',
      urgent: 'Urgent',
      exactDate: 'Date précise',
    },
    missionTypes: {
      meeting: 'Réunion',
      conference: 'Conférence',
      court: 'Tribunal',
      medicalAppointment: 'Rendez-vous médical',
      training: 'Formation',
      negotiation: 'Négociation commerciale',
      event: 'Événement',
      tradeShow: 'Salon professionnel',
      other: 'Autre',
    },
    platforms: {
      zoom: 'Zoom',
      teams: 'Microsoft Teams',
      meet: 'Google Meet',
      webex: 'Webex',
      other: 'Autre',
    },
    equipment: {
      booth: 'Cabine d’interprétation',
      headsets: 'Casques',
      microphones: 'Microphones',
      none: 'Aucun matériel requis',
    },
    deliveryModes: {
      email: 'E-mail',
      secureDownload: 'Téléchargement sécurisé',
      postal: 'Courrier postal',
      pickup: 'Retrait sur place',
    },
  },
};

function cloneFrWith(overrides) {
  return {
    ...sharedLabels.fr,
    ...overrides,
    steps: { ...sharedLabels.fr.steps, ...overrides.steps },
    stepTitles: { ...sharedLabels.fr.stepTitles, ...overrides.stepTitles },
    client: { ...sharedLabels.fr.client, ...overrides.client },
    service: { ...sharedLabels.fr.service, ...overrides.service },
    project: { ...sharedLabels.fr.project, ...overrides.project },
    delivery: { ...sharedLabels.fr.delivery, ...overrides.delivery },
    comments: { ...sharedLabels.fr.comments, ...overrides.comments },
    validation: { ...sharedLabels.fr.validation, ...overrides.validation },
    stepHints: { ...sharedLabels.fr.stepHints, ...overrides.stepHints },
    trust: { ...sharedLabels.fr.trust, ...overrides.trust },
    help: { ...sharedLabels.fr.help, ...overrides.help },
    pricing: { ...sharedLabels.fr.pricing, ...overrides.pricing },
    languages: { ...sharedLabels.fr.languages, ...overrides.languages },
    countries: { ...sharedLabels.fr.countries, ...overrides.countries },
    translationServices: { ...sharedLabels.fr.translationServices, ...overrides.translationServices },
    interpretingTypes: { ...sharedLabels.fr.interpretingTypes, ...overrides.interpretingTypes },
    documentTypes: { ...sharedLabels.fr.documentTypes, ...overrides.documentTypes },
    domains: { ...sharedLabels.fr.domains, ...overrides.domains },
    formats: sharedLabels.fr.formats,
    extras: { ...sharedLabels.fr.extras, ...overrides.extras },
    deadlines: { ...sharedLabels.fr.deadlines, ...overrides.deadlines },
    missionTypes: { ...sharedLabels.fr.missionTypes, ...overrides.missionTypes },
    platforms: sharedLabels.fr.platforms,
    equipment: { ...sharedLabels.fr.equipment, ...overrides.equipment },
    deliveryModes: { ...sharedLabels.fr.deliveryModes, ...overrides.deliveryModes },
  };
}

export const quoteFormFr = sharedLabels.fr;

export const quoteFormAr = cloneFrWith({
  title: 'طلب ترجمة عبر الإنترنت',
  subtitle: 'صفوا احتياجكم في بضع خطوات. الدفع الآمن بعد التأكيد.',
  successTitle: 'تم تسجيل الطلب!',
  successText: 'تم إنشاء طلبكم بنجاح. يمكنكم متابعته في مساحة العميل.',
  successOrder: 'رقم الطلب',
  viewOrders: 'عرض طلباتي',
  backHome: 'العودة إلى الرئيسية',
  next: 'التالي',
  prev: 'السابق',
  submit: 'تأكيد الطلب',
  submitting: 'جاري الإرسال…',
  loginToOrder: 'سجّل الدخول لتأكيد طلبك.',
  loginRestored: 'تم تسجيل الدخول. راجعوا طلبكم ثم اضغطوا « تأكيد الطلب ».',
  submitError: 'تعذّر حفظ الطلب. حاول مرة أخرى.',
  needLangPair: 'حددوا تركيبة لغات واحدة على الأقل.',
  needDocument: 'اختاروا نوع الوثيقة.',
  required: 'حقل إلزامي',
  optional: 'اختياري',
  addLangPair: 'إضافة تركيبة لغات',
  removeLangPair: 'إزالة',
  sourceLang: 'اللغة المصدر',
  targetLang: 'اللغة الهدف',
  choose: 'اختر…',
  stepOf: 'الخطوة',
  sideTitle: 'طلبكم',
  stepHints: {
    1: 'معلومات الاتصال',
    2: 'ترجمة أو ترجمة فورية',
    3: 'تركيبات اللغات',
    4: 'التفاصيل والملفات',
    5: 'طريقة الاستلام',
    6: 'تعليمات خاصة',
    7: 'المراجعة والإرسال',
  },
  trust: {
    fast: 'رد خلال 30 دقيقة عمل',
    payment: 'دفع آمن عبر الإنترنت',
    secure: 'معالجة الوثائق بسرية تامة',
  },
  help: {
    title: 'تحتاجون مساعدة؟',
    text: 'فريقنا يساعدكم في إعداد طلبكم.',
    call: 'اتصلوا بنا',
    write: 'راسلونا',
  },
  pricing: {
    title: 'تقدير السعر',
    document: 'الوثيقة',
    base: 'الترجمة',
    quantity: 'عدد الصفحات',
    apostilleOriginal: 'أبوستيل الوثيقة الأصلية',
    apostilleTranslated: 'أبوستيل الوثيقة المترجمة',
    total: 'المجموع التقديري',
    pending: 'اختاروا نوع الوثيقة لعرض السعر.',
    quoteOnly: 'السعر حسب عرض السعر',
    paymentNote: 'يتم الدفع الآمن بعد تأكيد الطلب.',
  },
  steps: {
    1: 'العميل',
    2: 'الخدمة',
    3: 'اللغات',
    4: 'المشروع',
    5: 'التسليم',
    6: 'ملاحظات',
    7: 'التأكيد',
  },
  stepTitles: {
    1: 'معلومات العميل',
    2: 'اختيار الخدمة',
    3: 'اللغات',
    4: 'معلومات المشروع',
    5: 'التسليم',
    6: 'ملاحظات',
    7: 'التأكيد',
  },
  client: {
    section: 'بيانات الاتصال',
    civility: 'الصفة',
    lastName: 'اللقب',
    firstName: 'الاسم',
    company: 'الشركة / المؤسسة',
    role: 'الوظيفة',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    country: 'البلد',
    city: 'المدينة',
  },
  service: {
    category: 'الفئة',
    translation: 'ترجمة',
    interpreting: 'ترجمة فورية',
    translationService: 'الخدمة المطلوبة',
    interpretingType: 'نوع الترجمة الفورية',
  },
  project: {
    documentType: 'نوع الوثيقة',
    domain: 'المجال',
    pages: 'عدد الصفحات',
    words: 'عدد الكلمات',
    fileCount: 'عدد الملفات',
    formats: 'صيغة الوثيقة',
    upload: 'رفع الملفات',
    uploadHint: 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, ZIP…',
    dragDrop: 'أضيفوا ملفاً واحداً أو أكثر',
    extras: 'خيارات إضافية',
    deadline: 'الموعد المطلوب',
    deadlineDate: 'تاريخ محدد',
    missionType: 'نوع المهمة',
    missionDate: 'تاريخ المهمة',
    startTime: 'وقت البداية',
    endTime: 'وقت النهاية',
    duration: 'المدة التقديرية',
    place: 'المكان',
    placeCountry: 'البلد',
    placeCity: 'المدينة',
    address: 'العنوان',
    mode: 'الوضع',
    onsite: 'حضوري',
    remote: 'عن بُعد',
    platform: 'المنصة',
    participants: 'عدد المشاركين',
    equipment: 'احتياج المعدات',
  },
  delivery: { mode: 'طريقة التسليم المطلوبة' },
  comments: {
    label: 'تعليمات خاصة',
    placeholder: 'قيود مصطلحية، مسرد مطلوب، تنسيق خاص، متطلبات العميل…',
  },
  validation: {
    accurate: 'أؤكد أن المعلومات المقدمة دقيقة.',
    privacy: 'أوافق على سياسة الخصوصية.',
    terms: 'أوافق على الشروط العامة.',
  },
  languages: {
    ar: 'العربية',
    fr: 'الفرنسية',
    en: 'الإنجليزية',
    it: 'الإيطالية',
    de: 'الألمانية',
    es: 'الإسبانية',
    ru: 'الروسية',
    pt: 'البرتغالية',
    tr: 'التركية',
    zh: 'الصينية',
    other: 'أخرى',
  },
  countries: {
    TN: 'تونس',
    FR: 'فرنسا',
    IT: 'إيطاليا',
    DE: 'ألمانيا',
    BE: 'بلجيكا',
    CH: 'سويسرا',
    CA: 'كندا',
    AE: 'الإمارات',
    SA: 'السعودية',
    MA: 'المغرب',
    DZ: 'الجزائر',
    other: 'أخرى',
  },
  translationServices: {
    official: 'ترجمة رسمية',
    sworn: 'ترجمة محلّفة',
    certified: 'ترجمة مصادق عليها',
    legal: 'ترجمة قانونية',
    technical: 'ترجمة تقنية',
    medical: 'ترجمة طبية',
    financial: 'ترجمة مالية',
    commercial: 'ترجمة تجارية',
    marketing: 'ترجمة تسويقية',
    it: 'ترجمة معلوماتية',
    scientific: 'ترجمة علمية',
    audiovisual: 'ترجمة سمعية بصرية',
    tourism: 'ترجمة سياحية',
    literary: 'ترجمة أدبية',
    luxury: 'ترجمة في مجال الرفاهية',
    digital: 'ترجمة رقمية',
    website: 'ترجمة مواقع إلكترونية',
    softwareLocalization: 'توطين برمجيات',
    appLocalization: 'توطين تطبيقات',
    seo: 'ترجمة SEO',
  },
  interpretingTypes: {
    simultaneous: 'ترجمة فورية متزامنة',
    consecutive: 'ترجمة فورية تتابعية',
    liaison: 'ترجمة فورية للربط',
    judicial: 'ترجمة فورية قضائية',
    medical: 'ترجمة فورية طبية',
    commercial: 'ترجمة فورية تجارية',
    phone: 'ترجمة فورية هاتفية',
    video: 'ترجمة فورية عبر الفيديو',
  },
  documentTypes: {
    civilStatus: 'وثيقة حالة مدنية',
    diploma: 'شهادة',
    passport: 'جواز سفر',
    idCard: 'بطاقة هوية',
    drivingLicense: 'رخصة سياقة',
    contract: 'عقد',
    judgment: 'حكم',
    notarialAct: 'عقد موثق',
    medicalReport: 'تقرير طبي',
    technicalManual: 'دليل تقني',
    catalog: 'كتالوج',
    brochure: 'كتيب',
    website: 'موقع إلكتروني',
    mobileApp: 'تطبيق جوال',
    softwareDocs: 'وثائق برمجية',
    scientificArticle: 'مقال علمي',
    cv: 'سيرة ذاتية',
    letter: 'رسالة',
    other: 'أخرى',
  },
  domains: {
    legal: 'قانوني',
    medical: 'طبي',
    technical: 'تقني',
    commercial: 'تجاري',
    financial: 'مالي',
    marketing: 'تسويقي',
    it: 'معلوماتي',
    scientific: 'علمي',
    tourism: 'سياحة',
    luxury: 'رفاهية',
    education: 'تعليم',
    industry: 'صناعة',
    other: 'أخرى',
  },
  extras: {
    proofreading: 'مراجعة لغوية',
    sameLayout: 'تنسيق مطابق للأصل',
    certified: 'ترجمة مصادق عليها',
    sworn: 'ترجمة محلّفة',
    enhancedPrivacy: 'سرية معززة',
  },
  deadlines: {
    standard: 'عادي',
    priority: 'ذو أولوية',
    urgent: 'عاجل',
    exactDate: 'تاريخ محدد',
  },
  missionTypes: {
    meeting: 'اجتماع',
    conference: 'مؤتمر',
    court: 'محكمة',
    medicalAppointment: 'موعد طبي',
    training: 'تدريب',
    negotiation: 'تفاوض تجاري',
    event: 'حدث',
    tradeShow: 'معرض مهني',
    other: 'أخرى',
  },
  equipment: {
    booth: 'كابينة ترجمة فورية',
    headsets: 'سماعات',
    microphones: 'ميكروفونات',
    none: 'لا حاجة لمعدات',
  },
  deliveryModes: {
    email: 'البريد الإلكتروني',
    secureDownload: 'تحميل آمن',
    postal: 'بريد ورقي',
    pickup: 'استلام من الموقع',
  },
});

export const quoteFormEn = cloneFrWith({
  title: 'Order a translation online',
  subtitle: 'Describe your need in a few steps. Secure payment after confirmation.',
  successTitle: 'Order placed!',
  successText: 'Your order was created successfully. You can track it in your client area.',
  successOrder: 'Order no.',
  viewOrders: 'View my orders',
  backHome: 'Back to home',
  next: 'Next',
  prev: 'Previous',
  submit: 'Confirm order',
  submitting: 'Sending…',
  loginToOrder: 'Log in to confirm your order.',
  loginRestored: 'You are logged in. Review your order, then click “Confirm order”.',
  submitError: 'Could not save the order. Please try again.',
  needLangPair: 'Provide at least one language pair.',
  needDocument: 'Select a document type.',
  required: 'Required field',
  optional: 'optional',
  addLangPair: 'Add a language pair',
  removeLangPair: 'Remove',
  sourceLang: 'Source language',
  targetLang: 'Target language',
  choose: 'Choose…',
  stepOf: 'Step',
  sideTitle: 'Your request',
  stepHints: {
    1: 'Your contact details',
    2: 'Translation or interpreting',
    3: 'Language pairs',
    4: 'Details and files',
    5: 'How you receive the work',
    6: 'Specific instructions',
    7: 'Review and send',
  },
  trust: {
    fast: 'Reply within 30 working minutes',
    payment: 'Secure online payment',
    secure: 'Documents handled confidentially',
  },
  help: {
    title: 'Need help?',
    text: 'Our team can help you prepare your request.',
    call: 'Call us',
    write: 'Write to us',
  },
  pricing: {
    title: 'Price estimate',
    document: 'Document',
    base: 'Translation',
    quantity: 'Number of pages',
    apostilleOriginal: 'Apostille — original doc.',
    apostilleTranslated: 'Apostille — translated doc.',
    total: 'Estimated total',
    pending: 'Select a document type to display the price.',
    quoteOnly: 'Price on request',
    paymentNote: 'Secure payment is completed after the order is confirmed.',
  },
  steps: {
    1: 'Client',
    2: 'Service',
    3: 'Languages',
    4: 'Project',
    5: 'Delivery',
    6: 'Comments',
    7: 'Confirm',
  },
  stepTitles: {
    1: 'Client information',
    2: 'Service selection',
    3: 'Languages',
    4: 'Project details',
    5: 'Delivery',
    6: 'Comments',
    7: 'Confirmation',
  },
  client: {
    section: 'Contact details',
    civility: 'Title',
    lastName: 'Last name',
    firstName: 'First name',
    company: 'Company / Organisation',
    role: 'Job title',
    email: 'Email',
    phone: 'Phone',
    country: 'Country',
    city: 'City',
  },
  service: {
    category: 'Category',
    translation: 'Translation',
    interpreting: 'Interpreting',
    translationService: 'Requested service',
    interpretingType: 'Interpreting type',
  },
  project: {
    documentType: 'Document type',
    domain: 'Domain',
    pages: 'Number of pages',
    words: 'Number of words',
    fileCount: 'Number of files',
    formats: 'Document format',
    upload: 'File upload',
    uploadHint: 'PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, JPG, PNG, ZIP…',
    dragDrop: 'Add one or more files',
    extras: 'Additional options',
    deadline: 'Desired deadline',
    deadlineDate: 'Exact date',
    missionType: 'Mission type',
    missionDate: 'Mission date',
    startTime: 'Start time',
    endTime: 'End time',
    duration: 'Estimated duration',
    place: 'Location',
    placeCountry: 'Country',
    placeCity: 'City',
    address: 'Address',
    mode: 'Mode',
    onsite: 'On site',
    remote: 'Remote',
    platform: 'Platform',
    participants: 'Number of participants',
    equipment: 'Equipment needs',
  },
  delivery: { mode: 'Preferred delivery method' },
  comments: {
    label: 'Special instructions',
    placeholder:
      'Terminology constraints, glossary to follow, specific layout, client requirements…',
  },
  validation: {
    accurate: 'I confirm that the information provided is accurate.',
    privacy: 'I accept the privacy policy.',
    terms: 'I accept the terms and conditions.',
  },
  languages: {
    ar: 'Arabic',
    fr: 'French',
    en: 'English',
    it: 'Italian',
    de: 'German',
    es: 'Spanish',
    ru: 'Russian',
    pt: 'Portuguese',
    tr: 'Turkish',
    zh: 'Chinese',
    other: 'Other',
  },
  countries: {
    TN: 'Tunisia',
    FR: 'France',
    IT: 'Italy',
    DE: 'Germany',
    BE: 'Belgium',
    CH: 'Switzerland',
    CA: 'Canada',
    AE: 'United Arab Emirates',
    SA: 'Saudi Arabia',
    MA: 'Morocco',
    DZ: 'Algeria',
    other: 'Other',
  },
  translationServices: {
    official: 'Official translation',
    sworn: 'Sworn translation',
    certified: 'Certified translation',
    legal: 'Legal translation',
    technical: 'Technical translation',
    medical: 'Medical translation',
    financial: 'Financial translation',
    commercial: 'Commercial translation',
    marketing: 'Marketing translation',
    it: 'IT translation',
    scientific: 'Scientific translation',
    audiovisual: 'Audiovisual translation',
    tourism: 'Tourism translation',
    literary: 'Literary translation',
    luxury: 'Luxury translation',
    digital: 'Digital translation',
    website: 'Website translation',
    softwareLocalization: 'Software localization',
    appLocalization: 'App localization',
    seo: 'SEO translation',
  },
  interpretingTypes: {
    simultaneous: 'Simultaneous interpreting',
    consecutive: 'Consecutive interpreting',
    liaison: 'Liaison interpreting',
    judicial: 'Judicial interpreting',
    medical: 'Medical interpreting',
    commercial: 'Business interpreting',
    phone: 'Telephone interpreting',
    video: 'Video remote interpreting',
  },
  documentTypes: {
    civilStatus: 'Civil status document',
    diploma: 'Diploma',
    passport: 'Passport',
    idCard: 'Identity card',
    drivingLicense: 'Driving licence',
    contract: 'Contract',
    judgment: 'Judgment',
    notarialAct: 'Notarial deed',
    medicalReport: 'Medical report',
    technicalManual: 'Technical manual',
    catalog: 'Catalogue',
    brochure: 'Brochure',
    website: 'Website',
    mobileApp: 'Mobile app',
    softwareDocs: 'Software documentation',
    scientificArticle: 'Scientific article',
    cv: 'CV',
    letter: 'Letter',
    other: 'Other',
  },
  domains: {
    legal: 'Legal',
    medical: 'Medical',
    technical: 'Technical',
    commercial: 'Commercial',
    financial: 'Financial',
    marketing: 'Marketing',
    it: 'IT',
    scientific: 'Scientific',
    tourism: 'Tourism',
    luxury: 'Luxury',
    education: 'Education',
    industry: 'Industry',
    other: 'Other',
  },
  extras: {
    proofreading: 'Linguistic proofreading',
    sameLayout: 'Layout identical to the original',
    certified: 'Certified translation',
    sworn: 'Sworn translation',
    enhancedPrivacy: 'Enhanced confidentiality',
  },
  deadlines: {
    standard: 'Standard',
    priority: 'Priority',
    urgent: 'Urgent',
    exactDate: 'Exact date',
  },
  missionTypes: {
    meeting: 'Meeting',
    conference: 'Conference',
    court: 'Court',
    medicalAppointment: 'Medical appointment',
    training: 'Training',
    negotiation: 'Business negotiation',
    event: 'Event',
    tradeShow: 'Trade show',
    other: 'Other',
  },
  equipment: {
    booth: 'Interpreting booth',
    headsets: 'Headsets',
    microphones: 'Microphones',
    none: 'No equipment required',
  },
  deliveryModes: {
    email: 'Email',
    secureDownload: 'Secure download',
    postal: 'Postal mail',
    pickup: 'On-site pickup',
  },
});
